import { Component } from '@angular/core';

@Component({
  selector: 'app-site-footer',
  template: `
    <footer class="site-footer">
      <div class="container">
        <p>&copy; {{ year }} Yeshua College</p>
      </div>
    </footer>
  `,
  styles: `
    .site-footer {
      background: var(--color-footer);
      color: #d7d7de;
      padding: 2rem 0;
    }

    .site-footer p {
      margin: 0;
      text-align: center;
      font-size: 0.95rem;
    }
  `
})
export class SiteFooterComponent {
  protected readonly year = new Date().getFullYear();
}
